import React, { useState } from 'react';
import styled from 'styled-components';
import OtpInput from 'react-otp-input';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const ResetPassword = () => {
  const [otp, setOtp] = useState('');
  const navigate = useNavigate();

  const serverHost = process.env.REACT_APP_SERVER_HOST
  
  const navigateTo = (path, userData = null) => {
    if (userData) {
      navigate(path, { state: { userData } });
    } else {
      navigate(path);
    }
  };
  const [waiting, setWaiting] = useState(false);
  const location = useLocation();
  const userData = location.state.userData;

  const handleVerify = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    
    formData.append('otp_id', userData.otp_id);
    formData.append('user_otp', otp);
    
    try {
      setWaiting(true);
      const response = await fetch(`${serverHost}/password-verify-email`, {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();

      if (response.status === 200) {
        navigateTo('/set-new-password', userData);
      } else {
        Swal.fire({
          title: 'Failed to validate otp',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to validate otp',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    } finally {
      setWaiting(false);
    }
  };

  return (
    <Container>
      <FormContainer>
        <LabelContainer>
          <Logo src="images/connectkgp.png" alt="connectKGP" />
          <Title>Verify Your Email</Title>
        </LabelContainer>
        <ImageContainer>
          <img src="images/otp.png" alt="OTP Icon" />
        </ImageContainer>
        <Form id="signInForm" onSubmit={handleVerify}>
          <Instruction>Enter the 5 digit OTP sent to your registered email</Instruction>
          <OtpInput
            inputType='number'
            inputStyle={{ color: '#6559a2', width: '40px', height: '40px' }}
            value={otp}
            onChange={setOtp}
            numInputs={5}
            renderInput={(props) => <Input {...props} />}
            shouldAutoFocus={true}
          />
          <VerifyButton type="submit" disabled={otp.length !== 5 || waiting}>
            {waiting ? <i className='fa fa-spinner' />: 'Verify'}
          </VerifyButton>
        </Form>
        <span style={{fontStyle: 'italic', fontSize: '12px'}}>
          * Please check spam folder if you can't find it in your inbox 
        </span>
      </FormContainer>
    </Container>
  );
};

export default ResetPassword;

const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 92vh;
  background-color: white;
`;

const FormContainer = styled.div`
  margin: auto auto;
  position: relative;
  width: 25%;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 0px;
  padding: 10px 10px;

  @media only screen and (max-width: 600px) {
    width: 90%;
  }
`;

const LabelContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  background: #6559a2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  height: 50px;
`;

const Title = styled.p`
  color: white;
  font-size: 20px;
`;

const ImageContainer = styled.div`
  text-align: center;
  background: transparent;
  padding: 0 20px;

  img {
    margin-top: 20%;
    background: transparent;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  padding: 10px;
`;

const Instruction = styled.span`
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
`;

const Input = styled.input`
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-left: 20px;

  &::selection {
    color: black;
  }
`;

const VerifyButton = styled.button`
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px 25px;
  background: #6559a2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;

  &:disabled {
    background: #d9d9d9;
    cursor: default;
    color: #6559a2;
    font-weight: bold;
  }


  i {
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

const SignInButton = styled.button``;